import React from 'react';
import Form from '../../components/common/Form';
import ReactGA from "react-ga";

class Subscription extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: "",
                password: ""
            },
            errors: {}
        };
    }
componentDidMount() {
   // ReactGA.pageview(window.location.pathname + window.location.search);

}

    render() {
        //console.log("Subscription", "Subscription this.props.location.pathname ", this.props.location.pathname);
        let h1_title = "Subscription";
        if(this.props.location.pathname === "/teams")
        {
            h1_title = "Teams";
        }
        else if(this.props.location.pathname === "/billing")
        {
            h1_title = "Billing";
        }
        return (
            <div>
                <h1  className='main-title'>{h1_title}</h1>
                <div className="separator"></div>
                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <h2>This section is currently under development.
                                It should be functional with our next version release, in a matter of days.
                                Thank you for your patience.</h2>
                            <img src="https://ikatdigital.com/wp-content/uploads/monkey.jpg" alt="Working On It"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Subscription